import Layout from "../../../components/layout/layout.js";

import BackgroundOverviewForm from "../../../components/form/background.form";

function BackgroundOverviewPage({ component, ...rest }) {
  return <Layout Component={BackgroundOverviewForm} controlsDisabled={true} {...rest} />;
}

export default BackgroundOverviewPage;
